module.exports = __webpack_public_path__ + "img/experiences_A Auto session.8c35b56b.jpg";